// Canonical evidence tier configuration used across dashboard, task list, and filters.
// Import this instead of defining tier labels/colors locally.

export const EVIDENCE_TIERS = [
  { key: 'auto_verified',      color: 'bg-green-500', hex: '#22c55e', label: 'Auto-Verified' },
  { key: 'manually_evidenced', color: 'bg-blue-500',  hex: '#3b82f6', label: 'Manually Evidenced' },
  { key: 'self_attested',      color: 'bg-amber-400', hex: '#f59e0b', label: 'Self-Attested' },
  { key: 'none',               color: 'bg-gray-400',  hex: '#9ca3af', label: 'No Evidence' },
];

// Keyed lookup for O(1) access by tier value.
export const EVIDENCE_TIER_MAP = Object.fromEntries(
  EVIDENCE_TIERS.map((t) => [t.key, t])
);
